<template>
    <div class="collect-items-container">
        <!-- 列表搜索过滤 -->
        <div class="search-wrap">
            <el-row :gutter="20">
                <el-col
                    class="search-btn-wrap"
                    :sm="24"
                    :md="24"
                    :lg="24"
                    :xl="24"
                    style="text-align: right;"
                >
                    <el-button size="medium" class="leader-common-button" @click="handleAdd()">新增</el-button>
                </el-col>
            </el-row>
        </div>
        <!-- 列表 -->
        <div class="table-wrap">
            <el-table
                border
                height="90%"
                :data="tableList"
                highlight-current-row
                class="leader-style-table"
                style="width: 100%"
            >
                <el-table-column width="50" align="center" label="序号">
                    <template slot-scope="scope">
                        <span>
                            {{
                                (pageNum - 1) * pageSize + scope.$index + 1
                            }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="id" property="pointClassId" align="center"></el-table-column>
                <el-table-column label="能源种类" property="className" align="center"></el-table-column>
                <el-table-column label="折标系数" property="zbxs" align="center"></el-table-column>
                <el-table-column label="排序" property="seqNum" align="center"></el-table-column>
                <el-table-column label="轮询-小时表名" property="hour_table_name" align="center"></el-table-column>
                <el-table-column label="轮询-小时record表名" property="hour_record_table_name" align="center"></el-table-column>
                <el-table-column label="轮询-天表名" property="day_table_name" align="center"></el-table-column>
                <el-table-column label="轮询-天record表名" property="day_record_table_name" align="center"></el-table-column>
                <el-table-column label="轮询-月表名" property="month_table_name" align="center"></el-table-column>
                <el-table-column label="轮询-月record表名" property="month_record_table_name" align="center"></el-table-column>
                <el-table-column label="需要轮询统计用量的字段名" property="class_q" align="center"></el-table-column>
                <el-table-column label="单位名" property="class_unit" align="center"></el-table-column>
                <el-table-column label="修改" align="center" width="210">
                    <template slot-scope="scope">
                        <div class="color-blue">
                            <el-button type="text" @click="handleDeleteItems(scope.row, '删除')">删除</el-button>
                            <div class="split-line"></div>
                            <el-button type="text" @click="handleEditItems(scope.row, '修改')">修改</el-button>
                            <div class="split-line"></div>
                            <el-button type="text" @click="handleAddItems(scope.row)">数据项</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                class="leader-style-pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNum"
                :page-sizes="[10, 20, 30, 40, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
            ></el-pagination>
        </div>
        <!-- 新增、修改 -->
        <el-dialog
            class="leader-dialog"
            :title="dialogAddTitle"
            width="850px"
            :visible.sync="dialogAddStatus"
            @close="closeAddDiaCb"
            :close-on-click-modal="dialogTitle !== '查看' ? false : true"
        >
            <div class="warn_txt">※修改时：数据库表不存在就会重新创建</div>
            <div class="plan-dialog-wrap" v-loading="diaLoading">
                <el-form
                    :model="addForm"
                    ref="addForm"
                    style="height: 100%"
                    class="leader-style-form"
                >
                    <el-form-item
                        label="能源种类"
                        label-width="200px"
                        prop="className"
                        :rules="[
                            {
                                required: true,
                                message: '请输入能源种类',
                                trigger: 'blur'
                            }
                        ]"
                    >
                        <el-input maxlength="20" v-model="addForm.className" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item
                        label="折标系数"
                        label-width="200px"
                        prop="zbxs"
                        :rules="[
                            {
                                required: true,
                                message: '请输入折标系数',
                                trigger: 'blur'
                            }
                        ]"
                    >
                        <el-input
                            maxlength="8"
                            v-model="addForm.zbxs"
                            autocomplete="off"
                            v-Int.float
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="排序"
                        label-width="200px"
                        prop="seqNum"
                        :rules="[
                            {
                                required: true,
                                message: '请输入排序',
                                trigger: 'blur'
                            }
                        ]"
                    >
                        <el-input
                            maxlength="6"
                            v-model="addForm.seqNum"
                            autocomplete="off"
                            v-Int
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="轮询-小时表名"
                        label-width="200px"
                        prop="hour_table_name"
                    >
                        <el-input
                            maxlength="60"
                            v-model="addForm.hour_table_name"
                            autocomplete="off"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="轮询-小时record表名"
                        label-width="200px"
                        prop="hour_record_table_name"
                    >
                        <el-input
                            maxlength="60"
                            v-model="addForm.hour_record_table_name"
                            autocomplete="off"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="轮询-天表名"
                        label-width="200px"
                        prop="day_table_name"
                    >
                        <el-input
                            maxlength="60"
                            v-model="addForm.day_table_name"
                            autocomplete="off"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="轮询-天record表名"
                        label-width="200px"
                        prop="day_record_table_name"
                    >
                        <el-input
                            maxlength="60"
                            v-model="addForm.day_record_table_name"
                            autocomplete="off"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="轮询-月表名"
                        label-width="200px"
                        prop="month_table_name"
                    >
                        <el-input
                            maxlength="60"
                            v-model="addForm.month_table_name"
                            autocomplete="off"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="轮询-月record表名"
                        label-width="200px"
                        prop="month_record_table_name"
                    >
                        <el-input
                            maxlength="60"
                            v-model="addForm.month_record_table_name"
                            autocomplete="off"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="需要轮询统计用量的字段名"
                        label-width="200px"
                        prop="class_q"
                    >
                        <el-input
                            maxlength="60"
                            v-model="addForm.class_q"
                            autocomplete="off"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="单位名"
                        label-width="200px"
                        prop="class_unit"
                    >
                        <el-input
                            maxlength="60"
                            v-model="addForm.class_unit"
                            autocomplete="off"
                        ></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button
                    v-if="dialogAddTitle !== '查看'"
                    @click="saveInfo"
                    class="leader-common-button"
                >保存</el-button>
                <el-button @click="dialogAddStatus = false" class="leader-common-button">取消</el-button>
            </div>
        </el-dialog>
        <!-- 数据项 -->
        <el-dialog
            class="leader-dialog"
            :title="dialogTitle"
            width="850px"
            :visible.sync="dialogStatus"
            @close="closeDiaCb"
            :close-on-click-modal="dialogTitle !== '查看' ? false : true"
        >
            <div class="plan-dialog-wrap" v-loading="diaLoading">
                <el-form
                    :model="commitForm"
                    ref="commitForm"
                    style="height: 100%"
                    class="leader-style-form"
                >
                    <el-scrollbar style="height: 100%">
                        <div class="search-wrap">
                            <el-row :gutter="20">
                                <el-col  :span="16">
                                    <el-form-item label="能源种类：" prop="name">
                                        <span style="color:#fff">
                                            {{
                                                curRow ? curRow.className : ""
                                            }}
                                        </span>
                                    </el-form-item>
                                </el-col> 
                                <el-col 
                                    :span="8"
                                    style="text-align: right;"
                                >
                                    <el-button
                                        size="medium"
                                        class="leader-common-button"
                                        @click="handleAddItem()"
                                    >新增</el-button>
                                </el-col>
                            </el-row>
                        </div>
                        <el-table
                            class="leader-style-table itemsTab"
                            :data="commitForm.datas"
                            height="19rem"
                            highlight-current-row
                            border
                            ref="tableRef"
                        >
                            <el-table-column label="分类" align="center">
                                <template slot-scope="scope">
                                    <el-form-item
                                        :prop="
                                            'datas.' +
                                            scope.$index +
                                            '.kindName'
                                        "
                                        :show-message="true"
                                        :rules="[
                                            {
                                                required: true,
                                                message: '请填写分类',
                                                trigger: 'blur'
                                            }
                                        ]"
                                    >
                                        <el-input v-model="scope.row.kindName" maxlength="20"></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column label="排序" align="center" width="150">
                                <template slot-scope="scope">
                                    <el-form-item
                                        :prop="
                                            'datas.' + scope.$index + '.seqNum'
                                        "
                                        :show-message="true"
                                        :rules="[
                                            {
                                                required: true,
                                                message: '请填写排序',
                                                trigger: 'blur'
                                            }
                                        ]"
                                    >
                                        <el-input
                                            v-model="scope.row.seqNum"
                                            maxlength="6"
                                            v-Int
                                        ></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column label="修改" align="center" width="150">
                                <template slot-scope="scope">
                                    <div>
                                        <el-button
                                            type="danger"
                                            size="small"
                                            v-if="scope.row.seq_num != '0'"
                                            @click="deleteItem(scope.row)"
                                        >删除</el-button>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-scrollbar>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button
                    v-if="dialogTitle !== '查看'"
                    @click="saveCollectItems"
                    class="leader-common-button"
                >保存</el-button>
                <el-button @click="closeDiaCb" class="leader-common-button">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import * as api from "@/http/api.js";
import moment from "moment";
export default {
    data() {
        return {
            tableList: [], //列表list
            pageNum: 1, //页码
            pageSize: 10, //每页条数
            currentPage: 1, //当前页码
            totalNum: 0, //总条数
            loading: false, //loading状态
            dialogStatus: false,
            dialogAddStatus: false,
            commitForm: {
                name: "",
                datas: []
            },
            addForm: {
                className: "",
                zbxs: "",
                seqNum: "",
                hour_table_name: "",
                hour_record_table_name: "",
                day_table_name: "",
                day_record_table_name: "",
                month_table_name: "",
                month_record_table_name: "",
                class_q: "",
                class_unit: ""
            },
            types: [
                {
                    code_value: "1",
                    code_name: "11111"
                }
            ],
            curRow: null
        };
    },
    created() {
        this.getPointClassList();
    },
    methods: {
        handleAdd() {
            this.dialogAddStatus = true;
            this.addForm = {
                className: "",
                zbxs: "",
                seqNum: "",
                hour_table_name: "",
                hour_record_table_name: "",
                day_table_name: "",
                day_record_table_name: "",
                month_table_name: "",
                month_record_table_name: "",
                class_q: "",
                class_unit: ""
            };
        },
        handleAddItems(row) {
            this.dialogStatus = true;
            this.curRow = row;
            api.getPointClassColumnKindSelect({
                pointClassId: row.pointClassId
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.commitForm = {
                        name: row.className,
                        datas: res.bus_json
                    };
                }
            });
        },
        handleDeleteItems(row){
            this.$confirm("确定删除这条数据吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(_ => {
                api.deletePointClassByPointClassId({
                    point_class_id: row.pointClassId
                }).then(res => {
                    if (res && res.error_code === '0') {
                        // 最后一页，只有一条数据时，点击删除
                        if (
                            this.totalNum -
                            (this.pageNum - 1) * this.pageSize ==
                            1
                        ) {
                            // 处理页码显示问题
                            this.pageNum =
                                this.pageNum == 1
                                    ? this.pageNum
                                    : this.pageNum - 1;
                        }
                        this.getPointClassList();
                        this.$message({
                            message: "删除成功",
                            type: "success"
                        });
                    }
                });
            });
        },
        handleEditItems(row) {
            this.dialogAddStatus = true;
            this.addForm = {
                className: row.className,
                zbxs: row.zbxs,
                seqNum: row.seqNum,
                pointClassId: row.pointClassId,
                hour_table_name: row.hour_table_name,
                hour_record_table_name: row.hour_record_table_name,
                day_table_name: row.day_table_name,
                day_record_table_name: row.day_record_table_name,
                month_table_name: row.month_table_name,
                month_record_table_name: row.month_record_table_name,
                class_q: row.class_q,
                class_unit: row.class_unit,
            };
        },
        handleAddItem() {
            let emptyItem = {
                kindName: "",
                seqNum: "" //排序
            };
            this.commitForm.datas.push(emptyItem);
        },
        saveInfo() {
            this.$refs["addForm"].validate(valid => {
                if (valid) {
                    api.saveOrUpdatePointClass(this.addForm).then(res => {
                        if (res.error_code == 0) {
                            this.$message({
                                type: "success",
                                message: res.error_msg
                            });
                            this.getPointClassList();
                            this.dialogAddStatus = false;
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        saveCollectItems() {
            this.$refs["commitForm"].validate(valid => {
                if (valid) {
                    if (
                        !(this.commitForm.datas && this.commitForm.datas.length)
                    ) {
                        this.$message({
                            type: "warning",
                            message: "请添加分类"
                        });
                        return;
                    }
                    const param = {
                        pointClassId: this.curRow.pointClassId,
                        list: this.commitForm.datas
                    };
                    api.beatchUpdatePointClassColumnKind(param).then(res => {
                        if (res && res.error_code === "0") {
                            this.$message({
                                type: "success",
                                message: res.error_msg
                            });
                            this.getPointClassList();
                        }
                        this.dialogStatus = false;
                    });
                } else {
                    return false;
                }
            });
        },
        deleteItem(sth) {
            // this.$confirm("确认删除这条数据吗？", "提示", {
            //     confirmButtonText: "确定",
            //     cancelButtonText: "取消",
            //     type: "warning"
            // }).then(_ => {
            this.commitForm.datas.forEach(function (item, index, arr) {
                if (item == sth) {
                    arr.splice(index, 1);
                }
            });
            // });
        },
        getPointClassList() {
            this.loading = true;
            api.getPointClassList({
                pageNum: this.pageNum,
                pageSize: this.pageSize
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.tableList = res.bus_json.items;
                    this.totalNum = res.bus_json.totalNum;
                }
                this.loading = false;
            });
        },
        closeAddDiaCb() {
            this.$refs.addForm.resetFields();
            //  this.dialogAddStatus = false;
            this.addForm = {
                className: "",
                zbxs: "",
                seqNum: "",
                hour_table_name: "",
                hour_record_table_name: "",
                day_table_name: "",
                day_record_table_name: "",
                month_table_name: "",
                month_record_table_name: "",
                class_q: "",
                class_unit: ""
            }
        },
        handleSizeChange(e) {
            this.pageNum = 1;
            this.pageSize = e;
            this.getPointClassList();
        },
        handleCurrentChange(e) {
            this.pageNum = e;
            this.getPointClassList();
        },
        closeDiaCb() {
            this.dialogStatus = false;
            this.commitForm.datas = [];
        },
    }
};
</script>
<style lang="scss">
.collect-items-container {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: px2Rem(20px);
    .leader-dialog .el-table--border::after,
    .el-table--group::after {
        width: 0;
    }
    // .leader-dialog .el-form-item {
    //     margin-bottom: 0 !important;
    // }
    .leader-dialog .el-dialog__body {
        padding-bottom: 0 !important;
    }
    .warn_txt {
        width: 100%; text-align: right; color: red;margin-bottom: 0.2rem;
    }
    .el-pagination {
        margin-top: 20px;
    }

    .button-green {
        color: #40be6c;
    }

    .button-red {
        color: #ff8971;
    }

    .button-blue {
        color: #0090e7;
    }

    .el-select {
        width: 100%;
    }

    .split-line {
        width: 2px;
        height: 12px;
        background: #adadad;
        display: inline-block;
        margin: 0 8px;
        vertical-align: middle;
    }

    // .search-btn-wrap {
    //     text-align: right;
    // }

    .search-wrap {
        .button-group {
            display: inline-block;
            margin-left: 20px;
            button {
                background: rgb(41, 184, 94);
                color: white;
                outline: none;
                border-color: rgb(41, 184, 94);
            }
            .el-button.is-disabled,
            .el-button.is-disabled:focus,
            .el-button.is-disabled:hover {
                border-color: #ebeef5;
            }
        }
    }
    // .itemsTab .el-form-item {
    //     margin-bottom: 0 !important;
    // }
}
</style>
